import { Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import {
  FormTitleBox,
  ConfirmationDialog,
} from '../../common/components';
import WarehousesDataTable from './components/WarehousesDataTable';
import WarehousesPagination from './components/WarehousesPagination';
import WarehouseDialog from './components/WarehouseDialog';
import { useWarehousesTable } from './hooks/useWarehousesTable';

const WarehousesTable = () => {
  const {
    data,
    branches,
    isLoading,
    totalPages,
    totalCount,
    page,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedWarehouse,
    deleteDialogOpen,
    warehouseToDelete,
    mutationsLoading,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleEdit,
    handleCreate,
    handleUpdate,
    handleDeleteRequest,
    handleConfirmDelete,
    handleCancelDelete,
  } = useWarehousesTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y compras | Depósitos"
        showButton
        buttonText="Nuevo depósito"
        buttonIcon={AddIcon}
        onButtonClick={handleOpenDialog}
        showSearch
        searchLabel="Buscar depósito"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <WarehousesDataTable
        data={data}
        branches={branches}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDeleteRequest}
      />

      {totalPages > 1 && (
        <WarehousesPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <WarehouseDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedWarehouse={selectedWarehouse}
        branches={branches}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        isSubmitting={mutationsLoading}
      />

      <ConfirmationDialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="depósito"
        message={
          warehouseToDelete
            ? `¿Confirmás eliminar el depósito "${warehouseToDelete.name}" (${warehouseToDelete.code})?`
            : '¿Confirmás eliminar el depósito seleccionado?'
        }
      />
    </Box>
  );
};

export default WarehousesTable;
